<template>
  <v-card min-width="21vw" light outlined>
    <v-card-title class="text-center" style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>Add Batch</h2></v-list-item-title>
        <v-spacer/>
        <v-icon class="icon" @click="close">fa-times</v-icon>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-5">
      <v-form v-model="valid">
        <v-text-field label="Batch Name" placeholder="Batch name" v-model="batchName" :rules="nameRules" outlined/>
        <v-date-picker v-model="proExpirationTimeString" color="green lighten-1"/>
        <div class="mb-3">
          <v-btn :disabled="!valid" @click="addBatch">Add Batch</v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
export default {
  name: "AddBatch",
  props: {
    club: Object,
  },
  data() {
    return {
      valid: false,
      batchName: '',
      proExpirationTimeString: null,
      proExpirationTime: null,

      nameRules: [
        n => !!n || 'Name is required',
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.proExpirationTime = Date.now();
      this.proExpirationTimeString = this.proExpirationTime.substr(0, 10);
    },
    addBatch() {
      let dateArray = this.proExpirationTimeString.split("-");
      let batch = {
        club: {
          id: Number(this.club.id),
        },
        name: this.batchName,
        proExpirationDate: new Date(
          Number.parseInt(dateArray[0]),
          Number.parseInt(dateArray[1]) - 1,
          Number.parseInt(dateArray[2])
        ),
      };

      Repository.createBatch(batch).then((response) => {
        if(response.status < 400) {
          alert('Batch created successfully!');
          this.$emit('created');
        }
      });
    },
    close() {
      this.$emit('closeWindow');
    },
  },
}
</script>

<style scoped>

</style>
